// extracted by mini-css-extract-plugin
var _1 = "Header-moduleheader__CmJXj";
var _2 = "Header-modulelogo__WRgfo CompanyLogo-moduleCompanyLogo__JTc6u";
var _3 = "Header-moduletext__idn6w EmailProfileRaw-moduletext__prNIu";
export { _1 as "header", _2 as "logo", _3 as "text" }
